import React from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import {
  IBlock,
  IButton,
  IImage,
  ILabel,
} from '../../../../utils/types/contentful';
import { formatContentfulComponentProps } from '../../../../utils/globals/index';
import { Disclosure } from '../../../UI/Navigation/Disclosure/disclosure';
import { Body } from '../../../UI/Elements/Body/body';
import { List } from '../../../UI/Navigation/List/list';
import { MicroDataHelmet } from '../../../Utils/MicroData/Utils/microDataHelmet';
import { collectionFAQMicroData } from '../../../Utils/MicroData/Collection/collectionFAQMicroData';
import { Divider } from '../../../UI/Elements/Divider';

export interface SiteReviewProps {
  label: ILabel;
  body: ILabel;
  image: IImage;
  buttons: IButton[];
  reviews: IBlock[];
}

const SeoDisclosureItem = ({ body, label, defaultOpen }) => {
  const disclosureButton = (
    <Label
      {...label}
      color={{ classname: 'gray-800' }}
      align='text-left'
      size='2xl'
      weight='light'
    />
  );

  const disclosureIcon = (
    <Icon
      iconKey='HiChevronDown'
      size='2xl'
      color={{ classname: 'gray-500' }}
    />
  );

  return (
    <div className='py-2'>
      <Disclosure
        defaultOpen={defaultOpen}
        button={disclosureButton}
        chevronIcon={disclosureIcon}
      >
        <div className='py-7'>
          <Body {...body} />
        </div>
      </Disclosure>
    </div>
  );
};

export const SeoDisclosure = ({ list, title }: MainReviewProps) => {
  const returnCollectionFAQMicroData = collectionFAQMicroData(list, title);

  return (
    <div className='py-4 pb-14 flex justify-center w-full'>
      <MicroDataHelmet schemaOrgJSONLD={returnCollectionFAQMicroData} />
      <div className='w-full lg:w-2/3'>
        <div className='flex mb-4 text-center justify-center py-10  w-full'>
          <Label
            {...title}
            color={{ classname: 'gray-800' }}
            weight='normal'
            size='4xl'
          />
        </div>
        <Divider color='gray-400' />
        <List
          divide
          listItems={list?.items.map((item, idx) => ({
            spacing: 'py-3',
            children: (
              <SeoDisclosureItem
                {...formatContentfulComponentProps(item)}
                defaultOpen={idx === 0}
              />
            ),
          }))}
        />
        <Divider color='gray-400' />
      </div>
    </div>
  );
};
